module.exports = __webpack_public_path__ + "img/5.f67dbc12.png";